import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";

const EditCategoryModal = ({
  category,
  toggleModal,
  showModal,
  onCategoryUpdated,
  categoryId,
}) => {
  const [categoryName, setCategoryName] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/category/singlecategory/${categoryId}`
        );
        if (!response.ok) throw new Error("Failed to fetch categories.");
        const data = await response.json();

        setCategoryName(data.name);
      } catch (error) {
        console.error("Fetch error:", error);
        toast.error("Error fetching categories.");
      }
    };
    fetchCategories();
  }, [categoryId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const bodyData = JSON.stringify({
      categoryName: categoryName,
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/category/updatecategory/${categoryId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: bodyData,
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");
      await response.json();
      toast.success("Category updated successfully!");
      resetFormFields();
      toggleModal();
      onCategoryUpdated();
    } catch (error) {
      console.error("Error:", error);
      toast.error(`Failed to update category: ${error.message}`);
    }
  };

  const resetFormFields = () => {
    setCategoryName(category.name);
  };

  const closingModal = () => {
    resetFormFields();
    toggleModal();
  };

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-navy-900 opacity-50"
        onClick={toggleModal}
      ></div>

      <div
        className={`fixed right-0 top-0 h-screen w-2/3 transform bg-white transition-transform ${
          showModal ? "translate-x-0" : "translate-x-full"
        } z-50 shadow-lg`}
      >
        <div className="flex h-full flex-col bg-navy-700">
          <div className="flex items-center justify-between bg-gray-500 p-3 shadow-md">
            <div className="flex-col">
              <h1 className="text-xl">Update Category</h1>
              <h1 className="text-lg">Update the category from here</h1>
            </div>
            <MdClose
              className="cursor-pointer rounded-full bg-navy-900 p-1 text-3xl text-white"
              onClick={closingModal}
            />
          </div>

          <form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="no-scrollbar h-full flex-col items-center overflow-y-scroll p-5 "
          >
            <div className="mb-5 flex w-full items-center justify-between">
              <h1 className="w-2/5 text-lg text-white">Category Name</h1>
              <input
                className="w-3/5 rounded-md p-2"
                type="text"
                placeholder="Category Name"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </div>

            <div className="mt-10 flex flex-wrap justify-center gap-2">
              <button
                type="submit"
                className="w-1/2 rounded-md bg-primary p-2 text-lg text-primaryText"
              >
                Update Category
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditCategoryModal;
